<app-alert-error [error]="lastError"></app-alert-error>
<div class="tdataLogin mb-2">
  <nz-upload
    class="d-block"
    [nzAction]="tdataApiUrl"
    [nzHeaders]="tdataHeaders"
    (nzChange)="handleChange($event)"
  >
    <button nz-button>
      Авторизоваться через<b> tdata </b>архив
    </button>
  </nz-upload>
</div>
<nz-alert *ngIf="interfaceService.isTelesellerDomain" nzType="success"
          [nzMessage]="descriptionAlertTdata"
          nzShowIcon></nz-alert>
<ng-template #descriptionAlertTdata>
  Приобрести архив для авторизации телеграм аккаунта можно на специализированных сайтах, например:<br>
  <a class="text-underline" target="_blank" href="https://darkstore.biz/products/catalog?sort=price&name=tdata&category_id=43&group_id=&feature=&price_from=0&price_to=10000&other%5B%5D=filled&p=53997">darkstore.biz</a>,
  такие аккаунты более устойчивы при рассылке и не так быстро банятся, покупайте со сроком отлежки не менее 10 дней, лучше от 1 до 2 месяцев. Покупайте у разных продавцов, <span class="badge badge-danger">исключительно +7 ...</span>
</ng-template>
